import { render } from "./UrlElementProduction.vue.js?vue&type=template&id=5dee8eda!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./UrlElementProduction.vue?vue&type=template&id=5dee8eda"
import script from "./UrlElementProduction.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./UrlElementProduction.vue?vue&type=script&lang=js"
export * from "./UrlElementProduction.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./UrlElementProduction.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-elements/url-element/UrlElementProduction.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5dee8eda"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5dee8eda', __exports__)) {
    api.reload('5dee8eda', __exports__)
  }
  
  module.hot.accept("./UrlElementProduction.vue.js?vue&type=template&id=5dee8eda!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./UrlElementProduction.vue?vue&type=template&id=5dee8eda", () => {
    api.rerender('5dee8eda', render)
  })

}


export default __exports__